import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import StatBadgeRow from "../common/StatBadgeRow";
import ProgressRow from "../common/ProgressRow";
import DualInlineBarChart from "../charts/DualInlineBarChart";
import { T } from "../../constants/theme";
import { productionData } from "../../data/dashboardMockData";

const WASTAGE_COLORS = [T.red, T.orange, T.yellow, T.purple];

const ProductionSection = ({ loading }) => (
  <Col xl={6} className="d-flex">
    <DashPanel
      title="Production Overview"
      icon="bx bx-cog"
      iconColor={T.teal}
      loading={loading}
    >
      <StatBadgeRow
        items={[
          { label: "Total Batches", value: productionData.totalBatches, color: T.blue },
          { label: "Completed", value: productionData.completedBatches, color: T.green },
          { label: "In Progress", value: productionData.inProgressBatches, color: T.yellow },
          { label: "Failed", value: productionData.failedBatches, color: T.red },
        ]}
        loading={loading}
      />

      <SectionTitle>Production vs Sale (Monthly)</SectionTitle>
      <DualInlineBarChart
        data={productionData.productionVsSale}
        labelKey="month"
        keyA="produced"
        labelA="Produced"
        keyB="sold"
        labelB="Sold"
        colorA={T.blue}
        colorB={T.green}
        formatValue={(v) => `${(v / 1000).toFixed(0)}k kg`}
        loading={loading}
      />

      <SectionTitle style={{ marginTop: "14px" }}>
        Wastage — {productionData.wastage.totalKg.toLocaleString()} kg &nbsp;
        <span style={{ color: T.red, fontWeight: 700 }}>
          ({productionData.wastage.percentOfProduction}%)
        </span>
      </SectionTitle>
      {productionData.wastage.byCategory.map((w, i) => (
        <ProgressRow
          key={i}
          label={w.category}
          value={`${w.kg} kg`}
          max={100}
          rawPct={w.percent}
          color={WASTAGE_COLORS[i % 4]}
          badge={`${w.percent}%`}
          loading={loading}
        />
      ))}
    </DashPanel>
  </Col>
);

export default ProductionSection;
